import { removeHtmlTags } from '@portal-internet/core';
import { _getUrl } from 'components/3cat/Enllac/Enllac';
import Enllac from 'components/corporatiu/Enllac/Enllac';
import __filter from 'lodash/filter';
import __isEmpty from 'lodash/isEmpty';
import Imatge from 'components/corporatiu/Imatge/Imatge';
import Icona from 'components/corporatiu/Icona/Icona';
import { useRef } from 'react';
import { EffectFade, Autoplay, Keyboard, Navigation, Pagination } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/autoplay';
import 'swiper/css/keyboard';
import 'swiper/css/pagination';
import 'swiper/css/effect-fade';
import { Swiper, SwiperSlide } from 'swiper/react';
import styles from './carrussel.module.scss';

export default function Carrussel(props) {
    const { items = {} } = props;

    const navigationPrev = useRef(null);
    const navigationNext = useRef(null);
    const paginationRef = useRef(null);

    const paginacio = {
        clickable: true,
        renderBullet: function (index, className) {
            const imatge = (
                items[index]?.imatges?.find((imatge) => imatge.rel_name === 'IMATGE_169') ||
                items[index]?.imatges?.find((imatge) => imatge.rel_name === 'IMAGE') ||
                items[index]?.imatges?.find((imatge) => imatge.rel_name === 'KEYVIDEO' && imatge.mida === 'MASTER')
            )?.text.replace('.jpg', '_320.jpg');

            return (
                '<div class="' +
                className +
                ' ' +
                styles.bullet +
                '"><p class=' +
                styles.bulletTitol +
                '>' +
                items[index].call_to_action +
                '</p><div class="' +
                styles.bulletImatgeWrapper +
                '"><img src="' +
                imatge +
                '" /></div></div>'
            );
        }
    };

    const _renderItems = () => {
        if (!__isEmpty(items)) {
            return Array.from(items)
                .slice(0, 5)
                .map((element, index) => {
                    const titol = removeHtmlTags(!__isEmpty(element.titol_promo) ? element.titol_promo : element.titol);
                    const avantitol = removeHtmlTags(element.avantitol);
                    const entradeta = removeHtmlTags(element.entradeta);
                    return (
                        <SwiperSlide key={index}>
                            <Enllac href={element.url} className={styles.enllac}>
                                <div className={styles.overlay}>
                                    <span className={styles.avantitol}>{avantitol}</span>
                                    <h2 className={styles.titol}>{titol}</h2>
                                    {/* <span className={styles.durada}>1 x 60&apos;</span> */}
                                    <p className={styles.entradeta}>{entradeta}</p>
                                </div>
                            </Enllac>
                            <div className={styles.imatge}>
                                <Imatge
                                    imatges={element.imatges}
                                    tipus='web_carrussel'
                                    alt={element.titol}
                                    layout='fill'
                                    objectFit='cover'
                                    priority={index === 0}
                                    className={styles.imatgeBlurred}
                                />
                                <div className={styles.imatgeWrapper}>
                                    <Imatge
                                        imatges={element.imatges}
                                        tipus='web_carrussel'
                                        alt={element.titol}
                                        layout='fill'
                                        objectFit='cover'
                                        priority={index === 0}
                                        className={styles.imatgeCarrussel}
                                    />
                                </div>
                            </div>
                        </SwiperSlide>
                    );
                });
        }
        return;
    };

    return (
        <div className={styles.wrapper}>
            <Swiper
                className={styles.carrussel}
                modules={[EffectFade, Keyboard, Pagination, Autoplay, Navigation]}
                navigation={{
                    prevEl: navigationPrev.current,
                    nextEl: navigationNext.current
                }}
                autoplay={{
                    delay: 3500,
                    disableOnInteraction: true
                }}
                loop={true}
                pagination={paginacio}
                effect={'fade'}
            >
                {_renderItems()}
            </Swiper>
            <div className={styles.fletxes}>
                <button ref={navigationPrev} className={styles.anterior}>
                    <Icona
                        icona='fletxa_simple_esquerra'
                        isBlanc={true}
                        alt='Anterior'
                        //mida={fletxes === 'mig' ? 26 : 30}
                        inline={true}
                        className={styles.iconaesquerra}
                        tabIndex={0}
                    />
                </button>
                <div className={styles.index} ref={paginationRef}></div>
                <button ref={navigationNext} className={styles.seguent}>
                    <Icona
                        icona='fletxa_simple_dreta'
                        isBlanc={true}
                        alt='Següent'
                        //mida={fletxes === 'mig' ? 26 : 30}
                        inline={true}
                        className={styles.iconadreta}
                        tabIndex={0}
                    />
                </button>
            </div>
        </div>
    );
}
